import React from 'react';
import { Space, Switch, Tooltip } from 'antd';
import { useAtom, useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';
import { pageMetaAtom , useCaseKeyAtom } from '@src/atoms/pageMeta';
import {
  dimensionPanelAtom,
  metricPanelAtom,
  summaryPanelAtom,
  flowToolbarPanelAtom,
} from '@src/atoms/panels';
import { isCDNAccountSelector } from '@store/common/selectors';
import { isEiModule, USECASE_KEY_WIDGET_DRILLDOWN, isAppModule } from '@utils/constants';
import { prefixedCheckFeature } from '@utils/platform/features/checkFeature';
import { compareOnTrendsModeSelector } from '@store/trends/base/selectors';
import { ToggleText, Header } from './styled';
import { isWidgetTabActiveAtom } from '@src/components/metrics-panel-hz/atoms';

const cf = prefixedCheckFeature('trends.sections');

function Panels() {
  const [summaryPanel, setSummaryPanel] = useAtom(summaryPanelAtom);
  const [metricPanel, setMetricPanel] = useAtom(metricPanelAtom);
  const [flowToolbarPanel, setFlowToolbarPanel] = useAtom(flowToolbarPanelAtom);
  const [dimensionPanel, setDimensionPanel] = useAtom(dimensionPanelAtom);
  const isCDNAccount = useSelector(isCDNAccountSelector);
  const isWidgetTabActive = useAtomValue(isWidgetTabActiveAtom);
  const useCaseKey = useAtomValue(useCaseKeyAtom);
  // override and disable summary on compare mode
  const compareMode = useSelector(compareOnTrendsModeSelector);
  const onToggleCheck = (setToggle) => (checked) => setToggle(checked);
  const enableForEi = isEiModule && !isCDNAccount && useCaseKey !== USECASE_KEY_WIDGET_DRILLDOWN;
  const { flowPresetId } = useAtomValue(pageMetaAtom);
  const flowPreset = isAppModule && !!flowPresetId;

  return (
    <Space direction="vertical">
      <Header>Page Sections</Header>
      {enableForEi && cf('summary', true) && !isWidgetTabActive && (
        <div>
          <Tooltip title={compareMode ? 'Disabled while on compare mode' : ''}>
            <Switch
              size="small"
              checked={summaryPanel && !compareMode}
              onChange={onToggleCheck(setSummaryPanel)}
              disabled={compareMode}
            />
            <ToggleText>Summary</ToggleText>
          </Tooltip>
        </div>
      )}
      {/* <div>
        <Switch checked={toolbarPanel} onChange={onToggleCheck(setToolbarPanel)} />
        <ToggleText>Toolbar</ToggleText>
      </div> */}
      {flowPreset && (
        <div>
          <Switch
            size="small"
            checked={flowToolbarPanel}
            onChange={onToggleCheck(setFlowToolbarPanel)}
          />
          <ToggleText>Flow Toolbar</ToggleText>
        </div>
      )}
      <div>
        <Switch size="small" checked={metricPanel} onChange={onToggleCheck(setMetricPanel)} />
        <ToggleText>Diagnostics</ToggleText>
      </div>
      <div>
        <Switch size="small" checked={dimensionPanel} onChange={onToggleCheck(setDimensionPanel)} />
        <ToggleText>Dimensions</ToggleText>
      </div>
    </Space>
  );
}

export default Panels;
